import React, {useState, useRef, useEffect} from 'react';
import {Share2, Twitter, Facebook, Instagram} from 'lucide-react';
import html2canvas from 'html2canvas';

const ShareMenu = ({contentRef, t}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const generateImage = async () => {
    if (!contentRef.current) return null;

    const wrapper = document.createElement('div');
    wrapper.style.padding = '32px';
    wrapper.style.backgroundColor = '#f8fafc';
    wrapper.appendChild(contentRef.current.cloneNode(true));
    document.body.appendChild(wrapper);

    try {
      const canvas = await html2canvas(wrapper, {
        backgroundColor: '#f8fafc',
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
      });

      document.body.removeChild(wrapper);
      return canvas.toDataURL('image/png');
    } catch (error) {
      console.error('Error generating image:', error);
      document.body.removeChild(wrapper);
      return null;
    }
  };

  const handleShare = async (platform) => {
    const image = await generateImage();
    if (!image) return;

    const shareData = {
      title: t.shareTitle,
      text: t.shareText,
      url: window.location.href
    };

    switch (platform) {
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(t.shareText)}&url=${encodeURIComponent(shareData.url)}`,
          '_blank'
        );
        break;
      case 'facebook':
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareData.url)}`,
          '_blank'
        );
        break;
      case 'instagram':
        const link = document.createElement('a');
        link.href = image;
        link.download = `japan-travel-map-${new Date().toISOString().slice(0, 10)}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alert(t.shareInstagramHint);
        break;
      default:
        if (navigator.share) {
          try {
            await navigator.share(shareData);
          } catch (error) {
            console.error('Error sharing:', error);
          }
        }
    }

    setIsOpen(false);
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg shadow-sm hover:bg-blue-700 transition-colors duration-200"
      >
        <Share2 className="w-4 h-4 mr-2"/>
        {t.share}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
          <button
            onClick={() => handleShare('twitter')}
            className="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center space-x-2"
          >
            <Twitter className="w-4 h-4"/>
            <span>Twitter</span>
          </button>
          <button
            onClick={() => handleShare('facebook')}
            className="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center space-x-2"
          >
            <Facebook className="w-4 h-4"/>
            <span>Facebook</span>
          </button>
          <button
            onClick={() => handleShare('instagram')}
            className="w-full px-4 py-2 text-left text-sm hover:bg-slate-50 flex items-center space-x-2"
          >
            <Instagram className="w-4 h-4"/>
            <span>Instagram</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ShareMenu;